import React from "react";

function Logo({item,src}:any) {

  return (
    <img
      style={{
        position: "absolute",
        top: item?.top,
        left: item?.left,
        height: item?.size,
        width: item?.size,
        display: item?.show ? "" : "none",
      }}
       crossOrigin="anonymous"
      src={src}
      alt=""
    />
  );
}

export default Logo;
